
const RegisterHtmlTemplate = require('polymer-webpack-loader/register-html-template');

RegisterHtmlTemplate.register("<dom-module id=home-header> <template> <style include=shared-style></style> <style>" + require("./home-header.css") + "</style> <div class$=\"side-container left [[isAppStyle]]\"> </div> <aofl-picture id=abc-logo> <aofl-img aofl-src=" + require("./images/abc_logo.png") + "></aofl-img> </aofl-picture> <div class=\"side-container right\"> <slot name=right></slot> </div> <aofl-picture id=child-safe> <aofl-img aofl-src=" + require("./images/child_safe.png") + "></aofl-img> <aofl-source media=\"(max-width: 568px)\" aofl-srcset=" + require("./images/child_safe_mobile.png") + "></aofl-source> </aofl-picture> </template> </dom-module>");

require('./home-header.js');



// WEBPACK FOOTER //
// ./home/en-US/js/home-header/home-header.html